import { operationInProgress, updateUser } from '../action/profile.action'
import ActionType from '../action.types'
import serviceInterface from '../../services/service.interface'
import SessionStorage from '../../util/sessionstore'
import { message } from 'antd'
import { fetchInProgress, serviceError } from './patient.action'

const session = new SessionStorage()

/*
Actions to be dispatched for signin
- Update Signature
    Get patient information for given company
- service error
*/

export function userFetchInProgress(isLoading) {
  return {
    type: ActionType.USER_INPROGRESS,
    isLoading,
  }
}

export function userList({ users, pagination, sorter, searchText, active }) {
  return {
    type: ActionType.USER_LIST,
    users,
    pagination,
    sorter,
    searchText,
    active,
    isLoading: false,
  }
}

export function visitedPage(page) {
  return {
    type: ActionType.UPDATE_USER_VISITED_PAGE,
    page,
  }
}

export function updateSignature(signature, user) {
  return async (dispatch) => {
    try {
      dispatch(fetchInProgress(true))
      var data = await serviceInterface
        .UserService()
        .updateSignature(signature, user._id)
      dispatch(fetchInProgress(false))
      if (data.error) {
        message.error('Internal server error!')
      } else {
        session.updateSignature(signature)
        dispatch(updateUser({ ...user, signature }))
      }
    } catch (err) {
      console.log(err)
      dispatch(fetchInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function fetchUsers(params) {
  return async (dispatch) => {
    try {
      dispatch(userFetchInProgress(true))
      var data = await serviceInterface.UserService().getUsers(params)
      dispatch(userFetchInProgress(false))
      if (data.error) {
        dispatch(serviceError(true, data.message))
      } else {
        data = { ...data, ...params }
        data.pagination.total = data.total
        if (!data.pagination.current) data.pagination.current = 1
        if (!data.pagination.pageSize) data.pagination.pageSize = 5
        dispatch(userList(data))
      }
    } catch (err) {
      console.log(err)
      dispatch(userFetchInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function getCompanyHealthcoach(params) {
  return async (dispatch) => {
    try {
      dispatch(userFetchInProgress(true))
      var data = await serviceInterface
        .UserService()
        .getCompanyHealthcoach(params)
      dispatch(userFetchInProgress(false))
      if (data.error) {
        dispatch(serviceError(true, data.message))
      } else {
        data = { ...data, ...params }
        return data
        // data.pagination.total = data.total;
        // dispatch(userList(data));
      }
    } catch (err) {
      console.log(err)
      dispatch(userFetchInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function addEditUser(params, id) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      var data = await serviceInterface.UserService().addEditUser(params, id)
      dispatch(operationInProgress(false))
      if (data.error) {
        message.error(data.message)
        return false
      } else {
        message.success(data.message)
        return data
      }
    } catch (err) {
      console.log(err)
      dispatch(operationInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function deleteUser(id) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      var data = await serviceInterface.UserService().deleteUser(id)
      dispatch(operationInProgress(false))
      if (data.error) {
        message.error(data.message)
        return false
      } else {
        message.success(data.message)
        return data
      }
    } catch (err) {
      console.log(err)
      dispatch(operationInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function putPatientOnHold({ isNew, patientid }) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      var data = await serviceInterface
        .UserService()
        .putPatientOnHold(isNew, patientid)
      dispatch(operationInProgress(false))
      if (data.error) {
        message.error(data.message)
        return false
      } else {
        message.success(data.message)
        return data
      }
    } catch (err) {
      console.log(err)
      dispatch(operationInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function setPassword(email, token, password) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      var data = await serviceInterface
        .AuthService()
        .changePassword({ email, token, password })
      dispatch(operationInProgress(false))
      if (data.error) {
        message.error(data.message)
        return false
      } else {
        message.success(data.message)
        return data
      }
    } catch (err) {
      console.log(err)
      dispatch(operationInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function sendResetPasswordLink(_id, email, captchaToken) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      var data = await serviceInterface
        .AuthService()
        .sendResetPasswordLink(_id, email, captchaToken)
      dispatch(operationInProgress(false))
      if (data.error) {
        message.error(data.message)
        // Return the payload rather than `false` when the server is asking for
        // a CAPTCHA: the page needs captcha_required to know to show the
        // widget. Every other failure keeps returning false as before.
        return data.captcha_required ? data : false
      } else {
        message.success(data.message)
        return data
      }
    } catch (err) {
      console.log(err)
      dispatch(operationInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function verifyActivityLinkOtp(data) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      var data = await serviceInterface
        .AuthService()
        .verifyActivityLinkOtp(data)
      dispatch(operationInProgress(false))
      if (data.error) {
        message.error(data.message)
        return false
      } else {
        message.success(data.message)
        return data
      }
    } catch (err) {
      console.log(err)
      dispatch(operationInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function updateUserVisitedPages(data, externalDispatch = null) {
  return async (dispatch) => {
    try {
      await serviceInterface.AuthService().updateUserVisitedPages(data)
      if (!externalDispatch) dispatch(visitedPage(data))
      else externalDispatch(visitedPage(data))
    } catch (err) {
      console.log(err)
    }
  }
}

export function getUserVisitedPages() {
  return async (dispatch) => {
    try {
      let res = await serviceInterface.AuthService().getUserVisitedPages()
      return res.pagevisited || []
    } catch (err) {
      console.log(err)
    }
  }
}
